<template>
  <div class="all">
    <router-view />
  </div>
</template>
<script>
import { useRouter } from "vue-router";

export default {
  name: "monitor",
  setup() {
    const router = useRouter();

    const admin = () => {
      if (
        localStorage.getItem("qlzx_monitoring_api_token") != null &&
        localStorage.getItem("qlzx_monitoring_api_token") != ""
      ) {
        let page = localStorage.getItem("selectTab_item");
        if (page != null) {
          router.push({ path: page });
        } else {
          router.push({ path: "/Login" });
        }
      } else {
        router.push({ path: "/Login" });
      }
    };
    admin()
    return {}
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  height: 100%;
}

#app {
  width: 100%;
  height: 100%;
}

li {
  list-style: none;
}

.all {
  width: 100%;
  height: 100%;
}
</style>
